import { useState, useEffect } from 'react'
import { Api } from 'utilities'
import { ObjectOption } from 'components/shared'

interface ProductResponse {
  id: number
  externalId?: number
  name: string
  mainImage?: {
    url?: string
  }
  images?: Array<{
    url?: string
  }>
  [key: string]: any
}

interface StoreViewResponse {
  products?: ProductResponse[]
  [key: string]: any
}

export const useGetProducts = (storeId: number, token: string) => {
  const [products, setProducts] = useState<ObjectOption[]>([])
  const [productsRawData, setProductsRawData] = useState<ProductResponse[]>([])
  const [storeData, setStoreData] = useState<StoreViewResponse | null>(null)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const [error, setError] = useState<Error | null>(null)

  useEffect(() => {
    if (!storeId || !token) {
      setIsLoading(false)
      return
    }

    setIsLoading(true)
    setError(null)

    Api.get<StoreViewResponse>(`/stores/${storeId}/view`, 'marketPlaceApi', {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
      .then((response) => {
        setStoreData(response)
        const productsList = response.products || []
        setProductsRawData(productsList)

        const transformedProducts: ObjectOption[] = productsList.map((product) => {
          // Get image URL from mainImage or first image, or use empty string
          const imageSrc = product.mainImage?.url || product.images?.[0]?.url || ''

          return {
            id: product.id,
            externalId: product.externalId,
            label: product.name || '',
            imageSrc
          }
        })

        setProducts(transformedProducts)
        setIsLoading(false)
      })
      .catch((err) => {
        setError(err)
        setIsLoading(false)
        console.error('Error fetching products:', err)
      })
  }, [storeId, token])

  return { products, productsRawData, storeData, isLoading, error }
}
